enum RoutePaths {
  Dashboard = '/',
}

export default RoutePaths;
